<!-- static content data from lang: company_management -->
<template>
    <div>
       <div class="h-100" v-loading="loading">
      <base-header class="pb-6">
        <div class="row align-items-center pb-4">
          <div class="col-lg-12 col-12">
            <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.AddheaderTitle}}</h6>
            <nav aria-label="breadcrumb" class="d-inline-block ml-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </div>
        </div>
      </base-header>
      <div class="container-fluid mt--6">
        <div>
          <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
            <div class="col-md-12">
              <template v-for="(message) in alertMessages">
                <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <template v-for="(message) in successMessages">
                <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-md-12">
                          <base-input
                            :label="lang.label.documentName"
                            name="document name"
                            autocomplete="off"
                            rules="required"
                            v-model="model.documentName"
                            labelClasses="form-control-label asterisk-mark"
                          ></base-input>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <div class="text-right mb-3">
                    <base-button type="primary" native-type="submit" :disabled="uploading">{{lang.label.buttons.save}}</base-button>
                    <base-button
                      type="danger"
                      @click="$router.push({path: 'list'})"
                    >{{lang.label.buttons.cancel}}</base-button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </card>
        </div>
      </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
   import Alert from "@/components/BaseAlert.vue";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";
  export default {
    components: {
      RouteBreadCrumb,
      vueDropzone: vue2Dropzone,
      Alert
    },
    data() {
      return {
        lang: this.$lang.document_management,
        loading:false,
        alertType: 'danger',
        successType: 'success',
        alertMessages: [],
        successMessages: [],
        uploading: false,
        model: {
          documentName: "",
        },
        dropzoneOptions: {
              url: "https://httpbin.org/post",
              thumbnailWidth: 200,
              addRemoveLinks: true,
              uploadMultiple: false,
              maxFilesize: 10,
              maxFiles: 1,
              acceptedFiles: ".jpg, .jpeg, .png",
              dictDefaultMessage:
                  "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
        }
      };
    },
    methods: {
      onSubmit() {
        let self = this;
        this.loading = true;
          let formData = new FormData();
              formData.append('name', this.model.documentName);
         
              this.$store.dispatch('postDocument', formData)
                      .then(response => {
                         if (response.status == 200) {
                        this.model.documentName = '';
                        console.log(response.data);
                        this.flash({message: response.data.message, variant: 'success'});
                          this.$router.push({ name: "documentManagement"});
                          this.loading = false;
                         }else {
                             if(typeof response.data.message != 'object'){
                                 this.alertMessages.push(response.data.message);
                             }else{
                                 let array = new Array();
                                 for (let key of Object.keys(response.data.message)) {
                                     let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                     array.push(obj)
                                 }
                                 this.alertMessages.push(array.join(', '));
                                 setTimeout(function () {
                                     self.alertMessages = [];
                                 },5000)
                             }
                                  this.loading = false;
                              }
  
                      })
                      .catch(error => {
                          this.loading = false;
                      })
        //
  
      }
    }
  };
  </script>
  <style>
  .no-border-card .card-footer {
    border-top: 0;
  }
  .modal-header {
    padding-bottom: 0;
  }
  </style>
  